import { render, staticRenderFns } from "./MainReportView.vue?vue&type=template&id=bf7b277e&scoped=true"
import script from "./MainReportView.vue?vue&type=script&lang=js"
export * from "./MainReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7b277e",
  null
  
)

export default component.exports